import styled from 'styled-components';

export const UploadsContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;

  max-height: 100px;
  overflow-y: scroll;
`;
